var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 480,
    height: 480,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M42 37a5 5 0 0 1-5 5H11a5 5 0 0 1-5-5V11a5 5 0 0 1 5-5h26a5 5 0 0 1 5 5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M33.03 25.6c-.65-.9-1.59-1.52-2.8-1.85 0 0 1.02-.37 1.94-1.75.55-.88.83-1.94.83-3.18 0-2.15-.78-3.8-2.34-4.93S27.34 12 24.35 12H15v24h10.43c2.83-.02 4.96-.63 6.41-1.8 1.44-1.19 2.16-2.95 2.16-5.3 0-1.3-.32-2.4-.97-3.3M21 16h4.25c1.52 0 2.75 1.23 2.75 2.75s-1.23 2.75-2.75 2.75H21zm5 16h-5v-6h5c1.66 0 3 1.34 3 3s-1.34 3-3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.fc57c01eff1e18b4757b5e22c3479b8b.svg";
export { ForwardRef as ReactComponent };